module.exports = __webpack_public_path__ + "static/media/errorSvg.228cce90.svg";